require("./checkbox-rounded.svg");
import "./style.scss";
